import React from 'react';
import PrimaryButton from './shared/PrimaryButton';
import SecondaryButton from './shared/SecondaryButton';
import SectionHeading from './shared/SectionHeading';
import FinalCTA from './home/FinalCTA';
import {
  PHONE_NUMBER,
  PHONE_NUMBER_LINK,
  PRIMARY_CTA_TEXT,
  SECONDARY_CTA_TEXT,
} from '../data/contact';

const ServiceDetail = ({ service }) => (
  <main>
    <section className="section service-focus-hero">
      <div className="container service-focus-hero-grid">
        <div>
          <p className="section-eyebrow">{service.eyebrow}</p>
          <h1>{service.pageTitle}</h1>
          <p className="service-focus-intro">{service.intro}</p>
          <div className="hero-actions">
            <PrimaryButton to="/contact">{PRIMARY_CTA_TEXT}</PrimaryButton>
            <SecondaryButton href={PHONE_NUMBER_LINK} aria-label={`Call Now at ${PHONE_NUMBER}`}>
              {SECONDARY_CTA_TEXT}
            </SecondaryButton>
          </div>
        </div>

        <aside className="card service-focus-summary" aria-label={`${service.title} summary`}>
          <p className="section-eyebrow">Service At A Glance</p>
          <h2>{service.title}</h2>
          <p>{service.description}</p>
          <SecondaryButton to="/service">View All Services</SecondaryButton>
        </aside>
      </div>
    </section>

    <section className="section section-surface">
      <div className="container service-focus-content">
        <div>
          <SectionHeading
            eyebrow="When To Call"
            title="Start with what you are noticing."
            description="These are common reasons homeowners reach out, but you do not need to diagnose the system before requesting service."
          />
          <ul className="card service-focus-list">
            {service.signs.map((sign) => (
              <li key={sign}>{sign}</li>
            ))}
          </ul>
        </div>

        <div>
          <SectionHeading
            eyebrow="What To Expect"
            title="A clear evaluation and practical next steps."
            description="The exact work depends on what the system needs. The visit begins with careful evaluation and straightforward communication."
          />
          <ul className="card service-focus-list">
            {service.included.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>

    <FinalCTA />
  </main>
);

export default ServiceDetail;
